/* eslint-disable camelcase */
export const Sources = {
  VDC: 'vdc',
  RDC: 'rdc',
} as const;

export const FilterKeys = {
  BUILD: 'build',
  OS: 'os',
  BROWSER: 'browser',
  TAG: 'tag',
  FRAMEWORK: 'framework',
  DEVICE: 'device',
  DEVICE_GROUP: 'deviceGroup',
  RESOURCE_TYPE: 'resourceType',
} as const;

export const RelativeDates = {
  today: 0,
  last7Days: 6,
  last14Days: 13,
  last30Days: 29,
  allTime: 30,
} as const;

export const ResourceTypes = Object.freeze({
  MAC_VMS: 'mac_virtual_machine',
  TOTAL_VMS: 'total_virtual_machine',
  VMS: 'virtual_machine',
} as const);

export type Source = typeof Sources[keyof typeof Sources];
export type FilterKey = typeof FilterKeys[keyof typeof FilterKeys];
export type RelativeDate = keyof typeof RelativeDates;
export type FetchStatus =
  | 'idle'
  | 'loading'
  | 'succeeded'
  | 'failed'
  | 'synchronized';
export type OwnerType = 'user' | 'team' | 'org';
export type RequestParam = null | string | string[];

export interface FilterItem {
  key: string;
  name: string;
  label: string;
}

export interface OwnerFilterItem extends FilterItem {
  type: OwnerType;
  id: string | null;
}

export type Filters = Record<FilterKey, FilterItem[]>;

export type SelectedFilters = Partial<Record<FilterKey, string[]>>;

export type FilterScopedPayload<T> = {
  values: T;
  key: FilterKey;
};

export type SourceScopedPayload<T extends Record<string, unknown>> = T & {
  source: Source;
};

export interface DateFilter {
  start?: string;
  end?: string;
}
export type DateTimeRequestParams = {
  start?: number;
  end?: number;
};

export type OwnerRequestParams = {
  org_id?: RequestParam;
  team_id?: RequestParam;
  user_id?: RequestParam;
};

export type FilterRequestParams = Partial<Record<FilterKey, RequestParam>>;

export type RequestParams = DateTimeRequestParams &
  OwnerRequestParams &
  FilterRequestParams;

export type ResourceType = typeof ResourceTypes[keyof typeof ResourceTypes];
